import * as Yup from 'yup';
import {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import {Stack, IconButton, InputAdornment} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import 'react-dropzone-uploader/dist/styles.css'
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import tracker from "../../../api/tracker";
import RHFFileInput from "../../../components/hook-form/RHFFileInput";
import RHFSearchableSelect from '../../../components/hook-form/RHFSearchableSelect';




// ----------------------------------------------------------------------

export default function UserForm({user}) {
  const navigate = useNavigate();
  const {t} = useTranslation()
  const [showPassword, setShowPassword] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState();
 
  const fetchEmployees = async () =>{
    const result = await tracker.get('employees/dropdown')
  
    setEmployees(result.data.data)
  }
  const fetchRoleData = async () =>{
    const result = await tracker.get('roles')
    setRoleList(result.data.data)
  }

  useEffect(() => {
    if (user) {
      const fields = ['email', 'hashid', 'role', 'id', 'employee_id', 'username'];
      fields.forEach(field => setValue(field, user[field]));
      // setEmployeeId({value: user.employee_id, label: user.employee.name})
      setEmployeeId(user.employee_id)
    }

    fetchRoleData()
    fetchEmployees()
  }, [user])

  const isEdit = Boolean(user);
  const UserSchema = Yup.object().shape({
    password: isEdit ? Yup.string() : Yup.string().required(t('Required')),
    email: Yup.string().email(t('Valid_email')).required('Required'),
    employee_id: Yup.string().required(t('Required')),
    username: Yup.string().min(6).max(25).matches(/^(?=[a-zA-Z0-9._]{8,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/, "No se permiten espacios, caracteres especiales. Tampoco puede terminar con rayita abajo o guión")
    .test(
      'username-backend-validation',
      'Ya hay un usuario con este nombre de usuario ',
      async (username) => {
        if (isEdit) return true;
        // Res from backend will be flag at res.data.success, true for username good
        const { data: { data } } = await tracker.post('users/testEmail', { username });
        return data.success;
      }
    ),
     
    // picture: Yup.mixed().test("fileSize", "The file is too large", (value) => {
    //   console.log(value)
    // return true
    // }),
  });

  const defaultValues = {
    username: '',
    password: '',
    email: '',
    employee_id: '',
    role: '',
    picture: null
  };
  // if(!user)
  //   user = defaultValues

  const methods = useForm({
    resolver: yupResolver(UserSchema),
    defaultValues,
  });

  const {
    handleSubmit,
      setValue,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if(data.picture)
      data.picture = data.picture[0];
    else
      data.picture = null;  
    if(!user)
      await tracker.post('register', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    else
      await tracker.post(`users/update/${user.id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    navigate('/dashboard/user', { replace: true });
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
       
        <RHFSearchableSelect name="employee_id" initialValue={employeeId} label={t('employee')} options={employees} />
        <RHFTextField name="email" label="Email address" />
        <RHFTextField name="username" label={t('username')}  />
        <input type="hidden" name="hashid" />
        <RHFTextField
          name="password"
          label="Password"
          autoComplete="new-password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
            ),
          }}
        />
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          {t('Save')}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
